<template>
  <a-modal
    :title="$t('page_material_warehousing_new')"
    :visible="visible"
    :width="1200"
    @cancel="close()"
  >
    <template slot="footer">
      <a-button key="back" :loading="loading" @click="close">
        {{ $t('cancel') }}
      </a-button>
      <a-button :loading="loading" key="submit0" type="primary" @click="() => point(1)">
        {{ $t('page_product_printing') }}
      </a-button>
      <a-button
        :loading="loading"
        v-if="inTypeCode != 'sparePartsStockIn'"
        key="submit1"
        type="primary"
        @click="() => save(1)"
      >
        {{ $t('page_product_temporary_storage') }}
      </a-button>
      <a-button :loading="loading" key="submit2" type="primary" @click="() => save(2)">
        {{ $t('page_material_warehousing') }}
      </a-button>
    </template>
    <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label="$t('page_material_warehousing_receipt_type')">
            <a-select
              show-search
              optionFilterProp="children"
              v-decorator="[
                'stockInTypeId',
                {
                  rules: [{ required: true, message: $t('page_material_warehousing_p_select') }]
                }
              ]"
              :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_type')"
              @change="handleChangeStock"
            >
              <a-select-option v-for="s in stockInList" :key="s.id" :value="s.id">
                {{ s.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('page_material_warehousing_receipt_time')">
            <a-date-picker
              v-decorator="[
                'receivingTime',
                {
                  rules: [{ required: true, message: $t('page_material_warehousing_p_input') }],
                  initialValue: dDate
                }
              ]"
              :placeholder="$t('please_select') + $t('page_material_warehousing_receipt_time')"
              style="width: 100%;"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <component
      ref="SaveForm"
      :is="componentId"
      :staff="staff"
      :depts="depts"
      :inTypeCode="inTypeCode"
      @changDefa="(value) => this.changDefa(value)"
      @chengeMaterial="(value) => chengeMaterial(value)"
    ></component>
    <component
      ref="SaveTable"
      :is="tableId"
      v-if="visible"
      :tableDef="tableDef"
      :areaId="areaId"
      :tableData="tableData"
    ></component>
  </a-modal>
</template>
<script>
import CommonForm from './Form/CommonForm'
import ProcessedForm from './Form/ProcessedForm'
import ProductForm from './Form/ProductForm'
import SparepartsForm from './Form/SparepartsForm'
import MaterialForm from './Form/MaterialForm'

import CreatTable from './Table/CreatTable'
import ProcessedTable from './Table/ProcessedTable'
import ProductTable from './Table/ProductTable'
import SparepartsTable from './Table/SparepartsTable'

import dayjs from 'dayjs'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { StockInOrderServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import _ from 'lodash'

const sosp = new StockInOrderServiceProxy()

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      materialAddList: [],
      loading: false,
      inTypeCode: '',
      tableData: '0',
      tableDef: {
        isPlan: false,
        selectPlan: '',
        planList: [],
        canAddTwo: false,
        hasOutOrder: false,
        isPlanAdd: true
      }
    }
  },
  components: {
    CreatTable,
    ProcessedTable,
    ProductTable,
    CommonForm,
    ProcessedForm,
    ProductForm,
    SparepartsForm,
    SparepartsTable,
    MaterialForm
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    areaId: {
      type: String,
      default: ''
    },
    staff: {
      type: Array,
      default: () => []
    },
    depts: {
      type: Array,
      default: () => []
    },
    stockInList: {
      type: Array,
      default: () => []
    },
    selectId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['materialPointDetail']),
    dDate() {
      return moment()
    },
    checkName(){
      return 'aaa'
    },
    planName(){
      return 'bbb'
    },
    componentId() {
      let id = ''
      switch (this.inTypeCode) {
        case 'productStockIn':
          id = 'product-form'
          break
        case 'processedStockIn':
          id = 'processed-form'
          break
        case 'sparePartsStockIn':
          id = 'spareparts-form'
          break
        case 'materialStockIn':
          id = 'material-form'
          break
        default:
          id = 'common-form'
          break
      }
      return id
    },
    tableId() {
      let id = ''
      switch (this.inTypeCode) {
        case 'productStockIn':
          id = 'product-table'
          break
        case 'processedStockIn':
          id = 'processed-table'
          break
        case 'sparePartsStockIn':
          id = 'spareparts-table'
          break
        default:
          id = 'creat-table'
          break
      }
      return id
    }
  },
  methods: {
    ...mapActions('app', ['saveMaterialPoint']),
    changDefa(value) {
      this.tableDef = value
    },
    handleChangeStock(value) {
      this.selectPlan = ''
      const data = this.stockInList.find((res) => res.id == value)
      this.inTypeCode = data ? data.code : ''
      this.form.setFieldsValue({
        planCode: '',
        outOrderCode: ''
      })
    },
    close() {
      this.reast()
      this.$emit('close')
    },
    // 校验表单
    checkForm() {
      if (this.$refs.SaveTable.editingKey !== '') {
        this.$message.warning(this.$t('page_material_ware_first_save_material'))
        return false
      }
      if (this.$refs.SaveTable.dataSource && this.$refs.SaveTable.dataSource.length < 1) {
        this.$message.warning(this.$t('page_material_ware_first_add_material'))
        return false
      }
      let mesg = 0
      this.$refs.SaveTable.dataSource.forEach((element, index) => {
        if (element.materialId === '') {
          this.$message.warning(this.$t('page_material_warehouse_item_not_selected'))
          mesg = mesg + 1
          return
        }
        if (element.areaId === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_area'))
          mesg = mesg + 1
          return
        }
        if (element.locationId === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_location'))
          mesg = mesg + 1
          return
        }
        if (element.stockInNum === undefined || element.stockInNum === null) {
          this.$message.warning(this.$t('page_material_ware_not_to_total_number'))
          mesg = mesg + 1
          return
        }
        if (!this.hasOutOrder && (element.totalNum === undefined || element.totalNum === null)) {
          this.$message.warning(this.$t('page_material_ware_not_to_stockin_number'))
          mesg = mesg + 1
          return
        }
      })
      if (mesg > 0) {
        return false
      } else {
        return true
      }
    },
    creatValues(values, model, sorp) {
      const list = this.$refs.SaveTable.dataSource.map((value) => {
        const res = { ...value }
        delete res.id
        delete res.barCode
        delete res.key
        return res
      })
      const stockIn = this.stockInList.find((res) => res.id === values.stockInTypeId)
      values.stockInTypeCode = stockIn ? stockIn.code : ''
      values.stockInTypeName = stockIn.name
      values.stockInOrderMaterialList = list
      values.receivingTime = dayjs(values.receivingTime).format('YYYY-MM-DD HH:mm:ss')
      values.model = model
      values.areaId = this.areaId

      values.deliveryUserName = this.$refs.SaveForm.deliveryUserName
      values.receivingDeptName = this.$refs.SaveForm.receivingDeptName
      values.receivingUserName = this.$refs.SaveForm.receivingUserName
      values.supplierName = this.$refs.SaveForm.supplierName

      this.saveReast(sorp, values)
    },
    // 保存表单
    save(model) {
      const bool = this.checkForm()
      console.log(bool)
      if (!bool) {
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$refs.SaveForm.save(values, (value) => this.creatValues(value, model, 'save'))
        }
      })
    },
    form2Save(value, model) {
      console.log(value, model)
    },
    // 打印
    point(model) {
      const bool = this.checkForm()
      if (!bool) {
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          const aa = this.$refs.SaveForm.save()
          console.log(aa)
          this.$refs.SaveForm.save(values, (value) => this.creatValues(value, model, 'point'))
        }
      })
    },
    // 保存后刷新
    saveReast(mode, data) {
      this.loading = true
      sosp
        .createStockInOrder(data)
        .then((res) => {
          if (res && mode === 'point') {
            this.checkPirnt(res)
          }
          this.$message.success(this.$t('page_user_management_new_success'))
          this.reast()
          this.$emit('reload')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 跳转打印
    checkPirnt(res) {
      sosp.getStockInOrderByCode(res).then((res) => {
        const lists = []
        if (res.stockInOrderMaterialVoList && res.stockInOrderMaterialVoList.length) {
          res.stockInOrderMaterialVoList.forEach((item) => {
            const user = this.supplierList.find((items) => items.id === item.supplierId)
            item.supplierName = user ? user.name : ''
            lists.push(item)
          })
        }
        const person = this.staff.find((items) => items.id === res.receivingUser)
        const materialPoint = {
          warehouse: 'in',
          orderCode: res.orderCode,
          code: res.deliveryCode,
          person: person ? person.name : '',
          time: res.receivingTime ? dayjs(res.receivingTime).format('YYYY-MM-DD HH:mm:ss') : '',
          list: lists
        }
        this.saveMaterialPoint(materialPoint)
        window.open('/material/point', '_blank')
      })
    },
    chengeMaterial(value) {
      this.tableData = Number(this.tableData) + 1 + ''
      this.$refs.SaveTable.dataSource = value
    },
    reast() {
      this.form.resetFields()
      this.loading = false
      this.inTypeCode = ''
      this.selectOrder = ''
      this.processList = [] // 工序列表
      this.selectProcess = ''
      this.tableData = '0'
    }
  }
}
</script>
<style scoped></style>
